import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer = ({ config }) => {
  const navigate = useNavigate();
  const [clickCount, setClickCount] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(0);

  useEffect(() => {
    // Reset click count if more than 3 seconds pass between clicks
    const timer = setTimeout(() => {
      if (clickCount > 0) {
        setClickCount(0);
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, [clickCount]);

  const handleFooterClick = () => {
    const now = Date.now();
    
    // Reset if too much time passed
    if (now - lastClickTime > 3000) {
      setClickCount(1);
    } else {
      const newCount = clickCount + 1;
      setClickCount(newCount);
      
      // If clicked 6 times, navigate to guest list
      if (newCount >= 6) {
        setClickCount(0);
        navigate('/guest-list');
      }
    }
    
    setLastClickTime(now);
  };

  return (
    <footer className="footer" style={{ background: `linear-gradient(to bottom, transparent, ${config.design.colors.footerColour})`, color: config.design.colors.primary }}>
      <div className="container">
        <p 
          style={{ fontFamily: config.design.fonts.heading, textAlign: 'center', cursor: 'pointer' }}
          onClick={handleFooterClick}
        >
          {config.couple.name1} & {config.couple.name2}
        </p>
        <p className="footer-credit" style={{ fontFamily: config.design.fonts.body, color: config.design.colors.primary }}>
          {config.content.footer.credit}
        </p>
      </div>
    </footer>
  );
};

export default Footer;

